import React, { useState, useEffect } from 'react';

import useCartState, { useCartActions } from '../../../hooks/useCartState';
import useCarePackAssociation from './useCarePackAssociation';

import CartItem from './cart-item';
import CartItemLoader, { reverseCartItems } from './cart-item-loader';
import EmptyCartMessage from './empty-cart-message';
import ProductRecommendations from '../product-recommendations';
import { hasSubscription } from './util';
import { getItemLevelCSR } from '../csr-component/util';

import './cart-items.less';

function CartItems({ onRecsReceived, csrActions }) {
    const [subscriptionPolicy, setSubscriptionPolicy] = useState(null);
    const { getSubscriptionPolicies } = useCartActions();
    const { cartInfo, cartViewIsLoading, emptyCart } = useCartState();
    const { id, cartView, items, cartDetails, ctoVerification = {}, disableCartAction } = cartInfo || {};
    const { orderItem = [] } = cartView || {};
    const { orderitemIds, csrOverrides } = cartDetails || {};
    const { carePackProps: carePackData, missingHW, refreshCarePackInfo } = useCarePackAssociation(orderItem);

    // while cartView is loading, use cart state as a hint to show skeleton loader
    const orderList = cartViewIsLoading ? reverseCartItems(items) : orderItem;
    const hasSub = hasSubscription(orderItem);
    useEffect(() => {
        if (hasSub) {
            getSubscriptionPolicies().then(setSubscriptionPolicy);
        }
    }, [hasSub]);

    return (
        <div className={`cart-items${cartViewIsLoading || !id ? ' loading' : ''}`}>
            {emptyCart && (
                <ProductRecommendations
                    variation="emptyCart"
                    PlaceHolder={EmptyCartMessage}
                    onRecsReceived={onRecsReceived}
                />
            )}
            {orderList.map((item, index) => {
                const { partNumber, orderItemId } = item || {};
                const itemDetails = orderitemIds && orderitemIds[orderItemId];
                const itemCsr = getItemLevelCSR(orderItemId, csrOverrides);
                const { ctoConfiguration } = itemDetails || {};

                return cartViewIsLoading ? (
                    <CartItemLoader key={index} item={item} />
                ) : (
                    <CartItem
                        key={orderItemId}
                        index={index}
                        cartId={id}
                        item={item}
                        CarePackProps={carePackData[partNumber]}
                        price={itemDetails}
                        subscriptionPolicy={subscriptionPolicy}
                        ctoError={ctoVerification[orderItemId]}
                        missingHW={missingHW.includes(orderItemId)}
                        refreshCarePackInfo={refreshCarePackInfo}
                        csrOverrides={itemCsr}
                        csrActions={csrActions}
                        disableAction={disableCartAction}
                        ctoConfiguration={ctoConfiguration}
                    />
                );
            })}
        </div>
    );
}

export default CartItems;
